/* eslint-disable max-len */
const getItemTransform = (item) => {
  const updatedItem = { ...item };
  const {
    id, name, content, ancestry: originalAncestry = [],
  } = updatedItem;

  if (updatedItem.content) {
    const ancestry = [...originalAncestry, { id, name }];
    updatedItem.content = content.map((child) => ({ ...child, ancestry }));
  }

  return updatedItem;
};

export default ({ data }) => data.reduce((rawItems, rawItem) => {
  const pushItem = (item) => {
    const transformedItem = getItemTransform(item);
    rawItems.push(transformedItem);

    if (transformedItem.content) transformedItem.content.forEach((contentItem) => pushItem(contentItem));
  };

  pushItem(rawItem);

  return rawItems;
}, []);
